import React from 'react';
import { Checkbox as MUICheckbox, CheckboxProps, makeStyles, alpha } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 0,
    width: 18,
    height: 18,
    border: '2px solid #B1A3B1', // Greyish border from design
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s, border 0.2s',
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(255,255,255,0.1)',
      borderColor: 'rgba(255,255,255,0.2)',
    },
  },
  checkedIcon: {
    backgroundColor: theme.palette.secondary.main, // Orange from the design
    border: `1px solid ${theme.palette.secondary.main}`,
    '&:before': {
      display: 'block',
      width: 12,
      height: 10,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.88614 8.69355C3.7225 8.85719 3.45719 8.85719 3.29355 8.69355L0.289843 5.68984C-0.0967564 5.30324 -0.0967556 4.67644 0.289844 4.28984C0.676443 3.90324 1.30324 3.90325 1.68984 4.28984L3.58984 6.18984L9.48985 0.289845C9.87644 -0.0967547 10.5032 -0.0967554 10.8898 0.289844C11.2764 0.676444 11.2764 1.30324 10.8898 1.68984L3.88614 8.69355Z' fill='white'/%3E%3C/svg%3E\")",
      content: '""',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    'input:disabled ~ &': {
      backgroundColor: alpha(theme.palette.secondary.main, 0.5),
      border: '1px solid transparent',
    },
  },
}));

export interface CustomCheckboxProps extends CheckboxProps { }

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ className, ...props }) => {
  const classes = useStyles();

  return (
    <MUICheckbox
      className={clsx(classes.root, className)}
      disableRipple
      color="default"
      checkedIcon={<div className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<div className={classes.icon} />}
      {...props}
    />
  );
};

export default CustomCheckbox;
